import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { useActivePatient } from "@/hooks/useActivePatient";
import { useActiveRole } from "@/hooks/useActiveRole";
import { Users } from "lucide-react";

/**
 * Always-visible active-patient switcher for carers in the top app bar.
 * Hidden for non-carer roles or when the carer has no assignments.
 */
export function PatientSwitcher() {
  const { activeRole } = useActiveRole();
  const { activePatientId, assignedPatients, setActivePatient } = useActivePatient();

  if (activeRole !== "carer" || assignedPatients.length === 0) return null;

  return (
    <div className="flex items-center gap-2">
      <Users className="h-4 w-4 text-muted-foreground shrink-0" />
      <Select
        value={activePatientId ?? ""}
        onValueChange={setActivePatient}
        disabled={assignedPatients.length === 1}
      >
        <SelectTrigger className="h-8 w-[160px] sm:w-[200px] text-xs">
          <SelectValue placeholder="Pick person" />
        </SelectTrigger>
        <SelectContent>
          {assignedPatients.map((p) => (
            <SelectItem key={p.id} value={p.id}>
              {p.full_name}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
}
